export function diffLines (a, b) {
  const n = a.length
  const m = b.length
  const dp = Array.from({ length: n + 1 }, () => new Uint32Array(m + 1))
  for (let i = 1; i <= n; i++) {
    for (let j = 1; j <= m; j++) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1] + 1
        : Math.max(dp[i - 1][j], dp[i][j - 1])
    }
  }

  const ops = []
  let i = n
  let j = m
  while (i > 0 || j > 0) {
    if (i > 0 && j > 0 && a[i - 1] === b[j - 1]) {
      ops.push({ type: 'equal', old: a[--i], new: b[--j] })
    } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
      ops.push({ type: 'added', new: b[--j] })
    } else {
      ops.push({ type: 'removed', old: a[--i] })
    }
  }
  ops.reverse()
  return ops
}

export function computeLineDiff (oldText, newText) {
  const oldSrc = (oldText || '').split('\n')
  const newSrc = (newText || '').split('\n')
  const ops = diffLines(oldSrc, newSrc)

  const removedRows = []
  const addedRows = []
  let oldRow = 0
  let newRow = 0

  for (const op of ops) {
    if (op.type === 'equal') {
      oldRow++
      newRow++
    } else if (op.type === 'removed') {
      removedRows.push(oldRow)
      oldRow++
    } else {
      addedRows.push(newRow)
      newRow++
    }
  }

  return { removedRows, addedRows, added: addedRows.length, removed: removedRows.length }
}
